import { render, staticRenderFns } from "./detailJob.vue?vue&type=template&id=1c7237fe&scoped=true&"
import script from "./detailJob.vue?vue&type=script&lang=js&"
export * from "./detailJob.vue?vue&type=script&lang=js&"
import style0 from "./detailJob.vue?vue&type=style&index=0&id=1c7237fe&scoped=true&lang=css&"
import style1 from "./detailJob.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7237fe",
  null
  
)

export default component.exports